import {TFunction} from 'react-i18next';

export const MINS_IN_HOUR = 60;

const FEW_COUNT_VALUES = [2, 3, 4];
const FEW_MINUTES_EXCEPTIONS = [12, 13, 14];
const MANY_HOURS_VALUES = [5, 6, 7];

export const calcHours = (minutes: number) => Math.trunc(minutes / MINS_IN_HOUR);
export const isTimeLessHour = (minutes: number) => minutes < MINS_IN_HOUR;

export const getMeetingRoomStatusMsg = (timeInMinutes: number, t: TFunction<'translation', undefined>) => {
  if (isTimeLessHour(timeInMinutes)) {
    const minuteRemainder = timeInMinutes % 10;

    if (FEW_COUNT_VALUES.includes(minuteRemainder) && !FEW_MINUTES_EXCEPTIONS.includes(timeInMinutes)) {
      return t('bookMeetingRoom.time.fewMinutesMore', {count: timeInMinutes});
    }

    if ((timeInMinutes === 1 || minuteRemainder === 1) && timeInMinutes !== 11) {
      return t('bookMeetingRoom.time.oneMinuteMore', {count: timeInMinutes});
    }
    if (timeInMinutes <= 0) {
      return t('bookMeetingRoom.time.lessMinute');
    }

    return t('bookMeetingRoom.time.manyMinutesMore', {count: timeInMinutes});
  }

  const hours = calcHours(timeInMinutes);
  if (hours === 1) {
    return t('bookMeetingRoom.time.oneHour');
  }

  if (FEW_COUNT_VALUES.includes(hours)) {
    return t('bookMeetingRoom.time.fewHours', {count: hours});
  }

  if (MANY_HOURS_VALUES.includes(hours)) {
    return t('bookMeetingRoom.time.manyHours', {count: hours});
  }

  return '';
};
